import SpaceBetween from '@cloudscape-design/components/space-between';
import { MarketingContainer, SectionHeader } from '@vextura/shell';
import type { ReactNode } from 'react';
import { DEMO } from '../content.js';

/**
 * Demo — placeholder card until we ship a real 30-second loop. Renders a
 * 16:9 dark box with a play icon and a "coming soon" caption. Swap in the
 * real video URL in content.ts and this section becomes an autoplay,
 * muted, looping element with no code change.
 */
export function Demo(): ReactNode {
  return (
    <MarketingContainer paddingY="default">
      <SpaceBetween size="xl">
        <SectionHeader
          eyebrow={DEMO.eyebrow}
          headline={DEMO.headline}
          subhead={DEMO.subhead}
        />
        <div
          style={{
            position: 'relative',
            width: '100%',
            aspectRatio: '16 / 9',
            maxWidth: 960,
            margin: '0 auto',
            background: '#0f1117',
            borderRadius: 16,
            border: '1px solid rgba(99, 102, 241, 0.25)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            overflow: 'hidden',
          }}
        >
          {DEMO.videoUrl ? (
            <video
              src={DEMO.videoUrl}
              autoPlay
              muted
              loop
              playsInline
              style={{ width: '100%', height: '100%', objectFit: 'cover' }}
            />
          ) : (
            <div style={{ textAlign: 'center', color: '#94a3b8' }}>
              <div
                style={{
                  width: 88,
                  height: 88,
                  borderRadius: '50%',
                  background: 'linear-gradient(135deg, rgba(99,102,241,0.35), rgba(168,85,247,0.35))',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  margin: '0 auto 20px',
                }}
              >
                <svg width="34" height="34" viewBox="0 0 24 24" fill="#f8fafc" aria-hidden>
                  <path d="M8 5v14l11-7z" />
                </svg>
              </div>
              <div style={{ fontSize: 15, fontWeight: 500 }}>
                30-second demo coming soon
              </div>
            </div>
          )}
        </div>
      </SpaceBetween>
    </MarketingContainer>
  );
}
